import { configureStore } from "@reduxjs/toolkit";
import generalReducer from "./slices/generalSlice";
import accountDetailReducer from "./slices/accountDetailSlice";
import activeComponentsReducer from "./slices/activeComponentsSlice";
import ouberReducer from "./slices/ouberSlice";

const store = configureStore({
  reducer: {
    generalSlice: generalReducer,
    accountDetailSlice: accountDetailReducer,
    activeComponentsSlice: activeComponentsReducer,
    ouberSlice: ouberReducer,
  },
});

export default store;
